import React from "react";
import { Instagram, Facebook, Youtube, Link2 } from "lucide-react";

export default function BlogPostShare() {
  return (
    <div className="flex items-center gap-3 sm:gap-4 px-0 sm:px-2">
      <span className="text-sm sm:text-[15px] font-medium text-slate-600 whitespace-nowrap">
        Share this post:
      </span>
      <div className="flex items-center gap-2 sm:gap-3">
        {[Instagram, Facebook, Youtube, Link2].map((Icon, i) => (
          <button
            key={i}
            aria-label="Share"
            className="w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-[#F3EEFA] text-[#7209B7] flex items-center justify-center hover:bg-purple-100 transition-colors shrink-0"
          >
            <Icon className="w-4 h-4 sm:w-[18px] sm:h-[18px]" />
          </button>
        ))}
      </div>
    </div>
  );
}
